import { compose } from 'redux';
import { connect } from 'react-redux';
import * as Action from '../../actions/CompanyManagementOrganizer';
import DetailCompanyOrganizer from '../../pages/CompanyManagementOrganizer/DetailCompanyOrganizer';
import DetailCompanyOrganizerSelector from '../../selectors/DetailCompanyOrganizer';
import { GetZonesRequested } from '../../actions/CommonOptions';
import withAuth from '../../common/WithAuth';

const detailCompanyRespone = DetailCompanyOrganizerSelector.createDetailCompanyOrganizerResultsSelector();
const mapStateToProps = (state) => ({
    locale: state.locale.lang.current,
    isAuthorized: state.auth.credential.isAuthorized,
    detailCompanyOrganizer: detailCompanyRespone(state),
    editSuccess: state.companyManagementOrganizer.editCompanyOrganizer.success,
    isLoading: state.companyManagementOrganizer.detailCompanyOrganizer.isFetching,
    eventInfo: state.registration.registrationViewer.data,
    options: state.commonOptions.Options.data,
    zones: state.commonOptions.zones.data,
    customText: state.adminSettingCustom.getCustomText.data || {},
});

const mapDispatchToProps = (dispatch) => ({
    fetchGetDetailCompanyOrganizer: () => {
        dispatch(Action.GetDetailCompanyOrganizerRequested());
    },
    fetchClearGetDetailCompanyOrganizer: () => {
        dispatch(Action.ClearGetDetailCompanyOrganizer());
    },
    fetchEventZones: (shortName) => {
        dispatch(GetZonesRequested(shortName));
    },
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(DetailCompanyOrganizer);
